import React, { useEffect, useState } from "react";

//redux
import { connect, useDispatch, useSelector } from "react-redux";

//MUI
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Tooltip,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";

//types
import { CLOSE_OUT_OF_COUNTRY_DIALOG } from "../../store/outOfCountryUser/types";

//action
import { updateAccessCode, toggleAccessCode } from "../../store/outOfCountryUser/action";

import { permissionError } from "../../util/Alert";

const OutOfCountryUserDialog = (props) => {
    const dispatch = useDispatch();

    const { dialog: open, outOfCountryUserSetting } = useSelector((state) => state.outOfCountryUser);
    const hasPermission = useSelector((state) => state.admin.admin.flag);

    const [accessCode, setAccessCode] = useState("");
    const [isActive, setIsActive] = useState(false);
    const [errors, setErrors] = useState({
        accessCode: "",
    });

    useEffect(() => {
        if (outOfCountryUserSetting) {
            setIsActive(outOfCountryUserSetting.countries?.universal?.isActive || false);
        }
    }, [outOfCountryUserSetting]);

    useEffect(
        () => () => {
            setAccessCode("");
            setErrors({ accessCode: "" });
        },
        [open]
    );

    useEffect(() => {
        window.onbeforeunload = closePopup();
    }, []);

    const closePopup = () => {
        dispatch({ type: CLOSE_OUT_OF_COUNTRY_DIALOG });
    };

    const handleUpdateAccessCode = (e) => {
        e.preventDefault();

        if (!accessCode.trim()) {
            return setErrors({ accessCode: "Access code is required!" });
        }

        if (!hasPermission) return permissionError();

        props.updateAccessCode(accessCode);
        setAccessCode("");
        setErrors({ accessCode: "" });
    };

    const handleToggleAccessCode = () => {
        if (!hasPermission) return permissionError();
        props.toggleAccessCode();
    };

    return (
        <>
            <Dialog
                open={open}
                aria-labelledby="responsive-dialog-title"
                onClose={closePopup}
                disableBackdropClick
                disableEscapeKeyDown
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle id="responsive-dialog-title">
                    <span className="text-danger font-weight-bold h4">
                        Out of Country User Access
                    </span>
                </DialogTitle>

                <IconButton
                    style={{
                        position: "absolute",
                        right: 0,
                    }}
                >
                    <Tooltip title="Close">
                        <Cancel className="text-danger" onClick={closePopup} />
                    </Tooltip>
                </IconButton>

                <DialogContent>
                    <div className="modal-body pt-1 px-1 pb-3">
                        <div className="d-flex flex-column">
                            <form>
                                <div className="form-group mt-4">
                                    <label className="text-gray mb-2">Access Status</label>
                                    <div className="d-flex align-items-center">
                                        <div className="custom-control custom-switch">
                                            <input
                                                type="checkbox"
                                                className="custom-control-input"
                                                id="accessToggle"
                                                checked={isActive}
                                                onChange={handleToggleAccessCode}
                                            />
                                            <label className="custom-control-label" htmlFor="accessToggle">
                                                {isActive ? (
                                                    <span className="text-success font-weight-bold">Enabled</span>
                                                ) : (
                                                    <span className="text-danger font-weight-bold">Disabled</span>
                                                )}
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group mt-4">
                                    <label className="mb-2 text-gray">Access Code</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter new access code"
                                        value={accessCode}
                                        onChange={(e) => {
                                            setAccessCode(e.target.value);
                                            if (!e.target.value.trim()) {
                                                return setErrors({
                                                    ...errors,
                                                    accessCode: "Access code is required!",
                                                });
                                            } else {
                                                return setErrors({
                                                    ...errors,
                                                    accessCode: "",
                                                });
                                            }
                                        }}
                                    />
                                    {errors.accessCode && (
                                        <div className="ml-2 mt-1">
                                            {errors.accessCode && (
                                                <div className="pl-1 text__left">
                                                    <span className="text-red">{errors.accessCode}</span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className="mt-5">
                                    <button
                                        type="button"
                                        className="btn btn-outline-info ml-2 btn-round float__right icon_margin"
                                        onClick={closePopup}
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-round float__right btn-danger"
                                        onClick={handleUpdateAccessCode}
                                        disabled={!accessCode.trim()}
                                    >
                                        Update
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default connect(null, { updateAccessCode, toggleAccessCode })(OutOfCountryUserDialog);
